export default "__VITE_ASSET__cUt7q6Ss__"